import Captcha from './Captcha'
import {Field, reduxForm} from 'redux-form'
import AuthField from 'components/Fields/AuthField'
import styles from './style.form.css'
import {connect} from 'react-redux'
import {
  NODE_ENV
} from 'env'
import validator from 'validator'

const validate = (values, props) => {
  const errors = {}
  if (!props.data.bars.length) {
    if (!values.email) {
      errors.email = 'The email address is required'
    } else if (!validator.isEmail(values.email)) {
      errors.email = 'The value is not a valid email address'
    }
    if (!values.password) {
      errors.password = 'The password is required'
    } else if (values.password.length < 6) {
      errors.password = 'Password at least have to be 6 characters long'
    }
    if (!values.confpassword) {
      errors.confpassword = 'The password is required'
    } else if (values.confpassword !== values.password) {
      errors.confpassword = 'The password and its confirm are not the same'
    }
    if (!values.captcha) {
      errors.captcha = 'The captcha is not valid'
    }
  }
  return errors
}

let RegisterForm = class registerForm extends React.Component {
  render () {
    let {handleSubmit, showChapcha} = this.props
    return (
      <div>
        <form onSubmit={handleSubmit} className={styles['register-form']} name='registerForm'>
          <Field
            component={AuthField}
            name='email'
            type='text'
            placeholder='Email'
            maxLength='255'
            autoCorrect='off'
            autoCapitalize='off'
            icon='fa fa-envelope-o'
            spellCheck='false' />
          <Field
            icon='fa fa-key'
            component={AuthField}
            name='password'
            type='password'
            placeholder='Password' />
          <Field
            icon='fa fa-lock'
            component={AuthField}
            name='confpassword'
            type='password'
            placeholder={`Confirm Password`} />
          {showChapcha === 'disablechapcha' && NODE_ENV === 'development'
          ? ''
          : <Field
            component={Captcha}
            name='captcha'
            />
          }
          <div className={styles['submit-btn']}>
            <button type='submit' className='btn btn-primary btn-block' id='btn-create-account' disabled={this.props.currentlySending}>
              {this.props.btnText}
            </button>
          </div>
        </form>
      </div>
    )
  }
}

RegisterForm.propTypes = {
  dispatch: React.PropTypes.func,
  data: React.PropTypes.object,
  onSubmit: React.PropTypes.func,
  changeForm: React.PropTypes.func,
  btnText: React.PropTypes.string,
  error: React.PropTypes.object,
  currentlySending: React.PropTypes.bool
}

RegisterForm = reduxForm({
  form: 'registerForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate
})(RegisterForm)

function select (state) {
  return {
    data: state.notification
  }
}

export default connect(select)(RegisterForm)



// WEBPACK FOOTER //
// ./app/pages/Register/RegisterForm.js